<div class='width-600'>

  <mat-card>
    <div class='img-box'>
      <img src="assets/images/geral/logo_azul.png">
    </div>
  </mat-card>

  <mat-card style="text-align: center; font-size: 1.5em;">
    ANUIDADE SBCCV
  </mat-card>

  <!--
  <mat-card *ngIf="!letter.name" style="height: 300px; text-align: center;">
    SEM ANUIDADE.
  </mat-card>
-->

  <div *ngIf="letter">

    <mat-card style="text-align: center;">
      <div>
        {{letter.name}}
      </div>
      <div>
        {{letter.subCategory_name}}
      </div>
    </mat-card>

    <mat-card *ngIf="payedDate" style="height: 260px;">
      <div class="payment-already-made">Pagamento realizado</div>
      <div class="payment-already-made">{{payedDate}}</div>


      <div *ngIf="invoiceUrl" class="invoiceUrl">
        <a matTooltip="Fatura" target='_blank' href={{invoiceUrl}}>
          FATURA - clique aqui
        </a>
      </div>

      <div *ngIf="receiptUrl" class="receiptUrl">
        <a matTooltip="Recibo" target='_blank' href={{receiptUrl}}>
          RECIBO - clique aqui
        </a>
      </div>

      <div *ngIf="!receiptUrl" class="receiptUrl">
        <div *ngIf="!receiptMessage">
          <button mat-raised-button (click)='gerarRecibo()'>
            <div class="letter-payed">Gerar Recibo</div>
          </button>
        </div>
         <div *ngIf="receiptMessage">
          {{receiptMessage}}
         </div>

      </div>

    </mat-card>

    <div *ngIf="!payedDate">

      <mat-card>
        <div class="price-wrapper">
          <div class="price">
            Anuidade(s)
          </div>
          <div class="price">
            <div> Valor</div>
          </div>
        </div>
        <div *ngIf="prices">
          <div class="price-wrapper" *ngFor="let annuity of letter.annuities">
            <div class="price" *ngIf="!annuity.isFree && annuity.value == 0">
              {{annuity.product_name}}
            </div>
            <div class="price" *ngIf="!annuity.isFree && annuity.value == 0">
              R$ {{prices.value}},00
            </div>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="hasCredit" style="text-align: center;">
        <div>
          Você tem um crédito de R$ {{letter.credit}},00
        </div>
        <div>
          <div class="use-credit-text">Qual valor deseja usar? </div>
          <input class="use-credit-value" matInput type="number" [readonly]="inputDisable" [(ngModel)]="discountValue"
            autocomplete="off">
        </div>
        <div>

          <button mat-raised-button [disabled]="!inputDisable" style="margin-right: 10px;" (click)='undoValueChange()'>
            defazer
          </button>

          <button mat-raised-button [disabled]="inputDisable" (click)='applyValueChange()'>
            aplicar
          </button>

          <div style="color:red; text-align: center;">
            {{msgCreditError}}
          </div>
        </div>
      </mat-card>

      <mat-card>
        <div *ngIf="prices">
          <div class="price-wrapper">
            <div class="price">
              Total
            </div>
            <div class="price">
              R$ {{valueTotalAnnuitues}},00
            </div>
          </div>
        </div>
      </mat-card>

      <mat-card class="display-wrapper">
        <div class="text-wrapper">
          <b>R$ {{valueTotalPixAnnuitues}},00</b>
          <div style="color: rgb(0, 52, 174);"> à vista com 5% de desconto</div>
        </div>
        <button class="button-pay" mat-raised-button (click)="selectPaymentType('pix')">Pagar com PIX</button>
      </mat-card>

      <mat-card class="display-wrapper">
        <div class="text-wrapper">
          <b>R$ {{valueTotalAnnuitues}},00</b>
          <div style="color: rgb(0, 52, 174);"> à vista no boleto</div>
        </div>
        <button mat-raised-button class="button-pay" (click)="selectPaymentType('billet')">Pagar com Boleto</button>
      </mat-card>

      <mat-card class="display-wrapper">
        <div class="text-wrapper">
          <b>R$ {{valueTotalAnnuitues}},00</b>
          <div style="color: rgb(0, 52, 174);"> em até 6 vezes no cartão</div>
        </div>
        <mat-radio-group class="white-radio" [(ngModel)]="selectedOption" (click)="clearErro()">
          <div class="radio-group-wrapper">
            <div *ngFor="let installment of cardInstallments">
              <mat-radio-button [value]="installment">
                {{ installment.installments }} {{ installment.text }} {{ installment.valueFormated }}
              </mat-radio-button>
            </div>
          </div>

          <div style="height: 20px;color: red; width: 100%; text-align: center;">
            {{msgErro}}
          </div>

          <form class="white-form form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

            <input matInput type="text" style="width: 254px; text-transform:uppercase" [errorStateMatcher]="matcher"
              [formControl]="entityForm.controls.holderName" placeholder="Nome no cartão" autocomplete="off">

             <div style=" margin-bottom: 10px;">

              <input #number1Input matInput type="text" inputmode="numeric" style="width: 40px; padding: 5px; margin-right: 2px;border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="4"
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.number1" placeholder="9999"
                autocomplete="off" (input)="autoAdvance($event, number2Input)">

              <input #number2Input matInput type="text" inputmode="numeric" style="width: 40px; padding: 5px; margin-right: 2px;border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="4"
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.number2" placeholder="9999"
                autocomplete="off" (input)="autoAdvance($event, number3Input)"
                (keyup)="autoRetreat($event, number1Input)">

              <input #number3Input matInput type="text" inputmode="numeric" style="width: 40px; padding: 5px; margin-right: 2px;border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="4"
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.number3" placeholder="9999"
                autocomplete="off" (input)="autoAdvance($event, number4Input)"
                (keyup)="autoRetreat($event, number2Input)">

              <input #number4Input matInput type="text" inputmode="numeric" style="width: 40px; padding: 5px; border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="4"
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.number4" placeholder="9999"
                autocomplete="off" (input)="autoAdvance($event, expiryMonth)"
                (keyup)="autoRetreat($event, number3Input)">
            </div>

            <div style=" margin-bottom: 10px;">

              <input #expiryMonth matInput type="text" inputmode="numeric" style="width: 35px; padding: 5px; border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="2"
                [errorStateMatcher]="matcher" [formControl]="entityForm.controls.expiryMonth" placeholder="mm"
                autocomplete="off" (input)="autoAdvance($event, expiryYear)"
                (keyup)="autoRetreat($event, number4Input)">

              <input #expiryYear matInput type="text" inputmode="numeric" style="width: 55px; padding: 5px; margin-left:2px; border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" maxlength="4" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.expiryYear" placeholder="aaaa" autocomplete="off"
                (input)="autoAdvance($event, ccvInput)" (keyup)="autoRetreat($event, expiryMonth)">

                <span style="font-size: 1em; margin-left: 10px; color: gray"><i>Ex: 10/2026</i></span>
            </div>
            <div>

              <input #ccvInput matInput type="text" inputmode="numeric" maxlength="4" style="width: 55px; padding: 5px; border: none; outline: none; background: white; -moz-appearance: textfield; appearance: textfield;" [errorStateMatcher]="matcher"
                [formControl]="entityForm.controls.ccv" placeholder="cvc" autocomplete="off"
                (keyup)="autoRetreat($event, expiryYear)">

                <style>
                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                  background-color: white;
                }
              </style>

            </div>

          </form>

        </mat-radio-group>

        <button class="button-pay" [disabled]="entityForm.invalid" style="margin-top: 10px;" mat-raised-button
          (click)="selectPaymentType('creditcard')">Pagar com Cartão</button>

        <br>
        <br>

      </mat-card>



    </div>

  </div>
  <!--
  <div *ngIf="!letter">
    <mat-card style="height: 300px;">
      <div class="not-found">
        Não encontramos correspondência para você.
      </div>
      <div style="width: 300px; margin: auto;">
        <div>
          O que pode estar acontecendo:
        </div>
        <ul>
          <li>Suas anuidades estão em dia.</li>
          <li>Sua categoria é isenta.</li>
          <li>E-mail não enviado, ainda.</li>
        </ul>
        <div>
          Dúvidas, entre em contato:
        </div>
        <div>
          sandra@sbccv.org.br
        </div>
      </div>

    </mat-card>
  </div>
-->

</div>


<br>
<br>
<br>
<br>
<br>
<br>
<br>
<br>